import { useEffect } from 'react';
import PropTypes from 'react-proptypes';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  CurrencyInputComponent,
  SwitchComponent,
  CheckboxComponent,
} from '@dnhb/node_package';
import { dispatchMapper, SYNC } from '../../../shared/wizard/actions';
import { shapeOutput, shapeInput } from '../config';
import Analytics from 'shared/utility/analytics';

const WizardSavings = ({dispatch, input, sync, output, forward, recalculating}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { errors } = output;

  useEffect(() => {
    dispatch({ type: SYNC, location, navigate, syncing: false });
    Analytics.send('Navigeer', 'Vermogen formulier');
  }, []);

  return (
    <form onSubmit={forward(recalculating, location, navigate)}>
      <input type="submit" className="hidden" />
      <div className="wrapper">
        <h2>Nog een paar laatste vragen</h2>
        <div className="row">
          <div className="group col-md-12">
            <h3>Heeft u eigen geld dat u wilt gebruiken om uw hypotheek af te lossen?</h3>
            <SwitchComponent
              id="has_own_resources"
              autoFocus
              onChangeHandler={sync('has_own_resources')}
              value={input.has_own_resources}
              errors={errors.has_own_resources}
            />
          </div>
        </div>
        {
          input.has_own_resources ? (
            <div className="row">
              <div className="group col-xs-12">
                <CurrencyInputComponent
                  id="own_resources"
                  onChangeHandler={sync('own_resources')}
                  value={input.own_resources}
                  errors={errors.own_resources}
                  label="Bedrag"
                />
              </div>
            </div>
          ) : null
        }
        <div className="row">
          <div className="group col-xs-12">
            <h3>
              Verwacht u op termijn een erfenis of ander vermogen
              dat u wilt gebruiken om uw hypotheek af te lossen?
            </h3>
            <SwitchComponent
              id="has_potential_resources"
              autoFocus
              onChangeHandler={sync('has_potential_resources')}
              value={input.has_potential_resources}
              errors={errors.has_potential_resources}
            />
          </div>
        </div>
        {
          input.has_potential_resources ? [
            <div key="potential_resources" className="row">
              <div className="group col-xs-12">
                <CurrencyInputComponent
                  id="potential_resources"
                  onChangeHandler={sync('potential_resources')}
                  value={input.potential_resources}
                  errors={errors.potential_resources}
                  label="Bedrag"
                />
              </div>
              <div className="col-xs-12">
                <CheckboxComponent
                  id="unknown_potential_resources"
                  onChangeHandler={sync('unknown_potential_resources')}
                  value={input.unknown_potential_resources}
                  label="Ik weet het bedrag nog niet"
                /><br />
              </div>
            </div>,
          ] : null
        }
        <div className="row">
          <div className="group col-md-12">
            <h3>Gaat u binnenkort kleiner wonen of huren?</h3>
            <SwitchComponent
              id="potential_living_expenses_reduction"
              autoFocus
              onChangeHandler={sync('potential_living_expenses_reduction')}
              value={input.potential_living_expenses_reduction}
              errors={errors.potential_living_expenses_reduction}
            />
          </div>
        </div>
      </div>
    </form>
  );
}

WizardSavings.propTypes = {
  sync: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  forward: PropTypes.func.isRequired,
  recalculating: PropTypes.number,
  input: shapeInput.isRequired,
  output: shapeOutput.isRequired,
};

WizardSavings.defaultProps = {
  recalculating: null,
};

export default connect(state => ({
  recalculating: state.recalculating,
  syncing: state.syncing,
  input: state.input,
  output: state.output,
}), dispatchMapper)(WizardSavings);
